// contexts/SocketContext.js
import React, { createContext, useContext, useEffect, useRef } from "react";
import { io } from "socket.io-client";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
const SocketContext = createContext();

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocket must be used within a SocketProvider");
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const userID = sessionStorage.getItem("userID");

  useEffect(() => {
    // Create socket connection only once
    if (!socketRef.current && userID) {
      socketRef.current = io(API_ORIGIN);

      socketRef.current.on("connect", () => {
        console.log("✅ Connected with socket id:", socketRef.current.id);
        socketRef.current.emit("join", userID);
        socketRef.current.emit("user-online", userID);
      });

      socketRef.current.on("joined", (data) => {
        console.log("🎉 Server says:", data);
      });

      socketRef.current.on("disconnect", () => {
        console.log("🔌 Disconnected from server");
      });
    }

    return () => {
      // Only disconnect when component unmounts completely
      // Don't disconnect here to maintain the single connection
    };
  }, [userID]);

  const joinRoom = (roomId) => {
    if (socketRef.current && roomId) {
      socketRef.current.emit("join-room", roomId);
      console.log(`👥 Joined chat room: ${roomId}`);
    }
  };

  const leaveRoom = (roomId) => {
    if (socketRef.current && roomId) {
      socketRef.current.emit("leave-room", roomId);
      console.log(`🚪 Left chat room: ${roomId}`);
    }
  };

  const value = {
    socket: socketRef.current,
    joinRoom,
    leaveRoom,
    isConnected: socketRef.current?.connected || false,
  };

  return (
    <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
  );
};
